import React  from "react";
import { RecoilRoot } from "recoil";

import Routes from "./routes";

import "./index.css";
import "./app.scss";

const App = () => {

  return (
    <RecoilRoot>
      <Routes />
    </RecoilRoot>

  )
};

export default App;